export const AuthRoles = {
    ANONYMOUS: 'ANONYMOUS',
    ADMIN: 'ADMIN',
    ARTIST: 'ARTIST'
}